const topics = [
  {
    tag: '动作片',
    title: '燃炸银幕 · 热血动作大片合集',
    desc: '高能打斗、极限追逐、硬汉对决 —— 肾上腺素全程拉满的动作盛宴，让你一次看个够。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20with%20dramatic%20explosive%20lighting%2C%20warm%20golden%20and%20deep%20crimson%20tones%2C%20cinematic%20wide%20shot%20with%20intense%20atmosphere%2C%20dark%20moody%20background%20with%20dramatic%20contrast%2C%20professional%20film%20photography%20style&width=800&height=500&seq=carousel-01&orientation=landscape',
    alt: '燃炸银幕动作大片合集',
  },
  {
    tag: '喜剧片',
    title: '欢乐无限 · 高分喜剧精选',
    desc: '从黑色幽默到温情喜剧，精选全球高分喜剧佳作，笑到停不下来的治愈时光。',
    img: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20comedy%20movie%20scene%20with%20vibrant%20warm%20colors%2C%20playful%20cinematic%20composition%2C%20happy%20energetic%20atmosphere%2C%20soft%20golden%20lighting%2C%20clean%20colorful%20background%2C%20professional%20film%20photography&width=800&height=500&seq=carousel-02&orientation=landscape',
    alt: '欢乐无限高分喜剧精选',
  },
  {
    tag: '经典电影',
    title: '光影不朽 · 百年经典回顾',
    desc: '那些经得起时间考验的传世之作，从黑白胶片到数字时代，重温电影艺术的永恒魅力。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20film%20scene%20with%20nostalgic%20warm%20sepia%20tones%2C%20elegant%20old%20Hollywood%20cinematic%20aesthetic%2C%20soft%20romantic%20lighting%2C%20textured%20film%20grain%2C%20timeless%20golden%20age%20cinema%20style&width=800&height=500&seq=carousel-03&orientation=landscape',
    alt: '光影不朽百年经典回顾',
  },
  {
    tag: '科幻片',
    title: '未来视界 · 科幻巨制巡礼',
    desc: '从太空史诗到人工智能，震撼的视觉奇观与深刻的哲学思考，打开想象的无限疆域。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20cosmic%20deep%20space%20atmosphere%2C%20dramatic%20neon%20and%20starlight%20tones%2C%20cinematic%20epic%20wide%20composition%2C%20dark%20mysterious%20background%20with%20subtle%20glow%2C%20professional%20film%20photography&width=800&height=500&seq=carousel-04&orientation=landscape',
    alt: '未来视界科幻巨制巡礼',
  },
  {
    tag: '动画片',
    title: '奇幻旅程 · 动画电影天地',
    desc: '从手绘经典到3D巨制，跨越国界的动画艺术，为每一个童心未泯的你打造梦幻世界。',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20animated%20film%20scene%20with%20whimsical%20fantasy%20atmosphere%2C%20warm%20magical%20lighting%20and%20rich%20colors%2C%20artistic%20cinematic%20composition%2C%20soft%20dreamy%20background%20with%20subtle%20texture%2C%20professional%20animation%20film%20style&width=800&height=500&seq=carousel-05&orientation=landscape',
    alt: '奇幻旅程动画电影天地',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-300 bg-accent-500/10 rounded-full mb-4">
            精选专题
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-3">
            精选专题放映
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-[560px] mx-auto">
            五大主题影展，从热血动作到奇幻动画，总有一部击中你的心
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {topics.map((item, idx) => (
            <div
              key={idx}
              className="group relative rounded-xl overflow-hidden bg-background-200 border border-background-300/40 cursor-pointer transition-all duration-300 hover:border-accent-500/30 hover:bg-background-300/50"
            >
              <div className="aspect-[4/3] overflow-hidden bg-background-300">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 text-xs font-medium text-accent-300 bg-accent-500/10 rounded-full mb-2">
                  {item.tag}
                </span>
                <h3 className="text-sm md:text-base font-bold text-foreground-100 mb-1 font-heading">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}